import {required, email, min_value, max_value} from "vee-validate/dist/rules";
import { extend } from "vee-validate";

extend("requiredarray", {
  validate(value) {
    console.log(value);
    return value && value.length > 0;
  },
  message: "Campo obligatorio",
});

extend("required", {
  ...required,
  message: "Campo Obligatorio",
});

extend("required-check", {
  validate(value) {
    return value === true;
  },
  message: "Campo Obligatorio",
});

extend("email", {
  ...email,
  message: "E-mail inválido",
});

extend("positive", (value) => {
  return value >= 0;
});

extend("odd", (value) => {
  return value % 2 !== 0;
});

extend("min", {
  validate(value, args) {
    return value.length >= args.length;
  },
  params: ["length"],
});

extend("max", {
  validate(value, args) {
    return value.length <= args.length;
  },
  params: ["length"],
});

extend("size", {
  validate(value, args) {
    return (
      value.toString().replaceAll(" ", "").replaceAll("-", "").length ===
      parseInt(args.length)
    );
  },
  params: ["length"],
  message: "El campo debería tener {length} caracteres",
});

extend("phone", {
  validate(value) {
    return (
      value.toString().replaceAll(" ", "").replaceAll("-", "").length === 10
    );
  },
  message: "El campo debería tener 10 caracteres",
});

extend("code", {
  validate(value, args) {
    if (value) {
      return (
        value.toString().replaceAll(" ", "").length === parseInt(args.length)
      );
    } else {
      return false;
    }
  },
  params: ["length"],
  message: "Código inválido",
});

extend("requiredcode", {
  validate(value) {
    return value.toString().replaceAll(" ", "").length > 0;
  },
  message: "El código es requerido",
});

extend("min_value", {
  validate(value, args) {
    return value >= args;
  },
  ...min_value,
  message: "El valor no debe ser menor a {min}",
});

extend("max_value", {
  validate(value, args) {
    return value <= args;
  },
  ...max_value,
  message: "El valor no debe ser mayor a {max}",
});
